import { TocAnchor } from './TocAnchor'

export default TocAnchor
